/** 
 * © 2025 COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 'CONTPAQi'. Todos los derechos reservados. 
 * Este código fuente constituye una obra original protegida por la legislación nacional e internacional en materia de propiedad intelectual. 
 * Su reproducción, distribución, comunicación pública, transformación, descompilación, ingeniería inversa o cualquier uso no autorizado, 
 * total o parcial, se encuentra expresamente prohibido sin la previa autorización por escrito de COMPUTACIÓN EN ACCIÓN, S.A. DE C.V. 
 * El uso indebido de este software puede ser constitutivo de delitos y dará lugar a las responsabilidades civiles y penales correspondientes. 
*/ 
 
import { Link } from "react-router-dom";
import { useState, useEffect } from "react";
import { TypeLogo } from "src/constants/theme.constant";

interface LogoProps {
  linkTo?: string,
  alt?: string,
  color?: string,
  className?: string,
};

const Logo = ({linkTo, alt, className, color}:LogoProps) => {
  const [typeLogo, setTypeLogo] = useState<string>(TypeLogo.Default);

  useEffect(() => {
    configLogo();
  }, []);

  useEffect(() => {
    configLogo();
  }, [color]);

  const configLogo = () => {
    const colorsLogo: string[] = Object.values(TypeLogo);
    if(color && colorsLogo.includes(color)){
      setTypeLogo(color);
    } else {
      setTypeLogo(TypeLogo.Default);
    }
  };

  return (
    <>
      {linkTo ? (
        <Link to={linkTo}>
          <img className={className ?? 'logo-img'} src={`/images/logo-${typeLogo}.svg`} alt={alt ?? 'Logo Contpaqi'} />
        </Link>
      ): (
        <img className={className ?? 'logo-img'} src={`/images/logo-${typeLogo}.svg`} alt={alt ?? 'Logo Contpaqi'} />
      )}
    </>
  );
};

export default Logo;
